import adminHttp from "@/api/adminHttp";

const BASE = '/api/ai-chat';

export default {
    getSessions: (params = { per_page: 15 }) => adminHttp.get(`${BASE}/sessions`, { params }),
    createSession: (data = { title: null }) => adminHttp.post(`${BASE}/sessions`, data),
    getSession: (id) => adminHttp.get(`${BASE}/sessions/${id}`),
    deleteSession: (id) => adminHttp.delete(`${BASE}/sessions/${id}`),
    getMessages: (id, params = { per_page: 100 }) => adminHttp.get(`${BASE}/sessions/${id}/messages`, { params }),

    getBusinessPrompt: () => adminHttp.get(`${BASE}/business-prompt`),
    getBusinessPromptHistory: (params = { per_page: 20 }) => adminHttp.get(`${BASE}/business-prompt/history`, { params }),
    updateBusinessPrompt: (data) => adminHttp.put(`${BASE}/business-prompt`, data),
};
